import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateSendToModeration = {
  sendToModeration: { data: null, loading: false, error: null },
};

export const sendToModeration = createAsyncThunk('user/sendToModeration', async (id, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .post(
      `${process.env.REACT_APP_SERVER_API}/vacancies/${id}/to-moderation`,
      {},
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      },
    )
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerSendToModeration = {
  [sendToModeration.pending]: (state) => {
    state.sendToModeration.loading = true;
    state.sendToModeration.error = null;
  },
  [sendToModeration.fulfilled]: (state, action) => {
    state.sendToModeration.loading = false;
    state.sendToModeration.data = true;
    state.sendToModeration.error = null;
  },
  [sendToModeration.rejected]: (state, action) => {
    state.sendToModeration.loading = false;
    state.sendToModeration.error = action.payload;
  },
};
